module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag49_2342AT.02b264f4.jpg";